import firebase from "firebase/compat/app";
import "firebase/compat/auth";
import React, { useEffect, useState } from "react";
import { Redirect } from "react-router-dom";
import EmailVerification from "./EmailVerification";
import PhoneVerification from "./PhoneVerification";
import firebaseService from "../../../services/firebase";
import AuthPageLayout from "../AuthPageLayout";

const MFAEntroll = () => {
  const [isEmailVerified, setIsEmailVerified] = useState(false);
  const currentUser = firebaseService.currentUser();

  useEffect(() => {
    firebase.auth().onIdTokenChanged(function (user) {
      if (user && user.uid) {
        if (user.emailVerified && !isEmailVerified) {
          setIsEmailVerified(true);
        }
      }
    });
  }, [isEmailVerified]);

  if (!currentUser) {
    return <Redirect to="/" />;
  }

  return (
    <AuthPageLayout
      title="Turn on multi-factor authentication"
      subtitle={isEmailVerified ? "Verify your phone number" : "Verify your email address"}
    >
      {!isEmailVerified && <EmailVerification setIsEmailVerified={setIsEmailVerified} />}
      {isEmailVerified && <PhoneVerification />}
    </AuthPageLayout>
  );
};

export default MFAEntroll;
